import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './AboutPage.less';

const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <div className="aboutPage">

      <h2>About</h2>

      <div className="aboutSection">
        <p>
          Although <span className="italicText">The Daily Baffle</span> often employs "the royal we" to maintain the illusion of an editorial staff, it is largely a solo endeavour designed and built by Julian Eden, a developer from the Northeast US.
        </p>
        <p>
          All our puzzle formats are original creations designed in a notebook in the spring of 2024.
        </p>
        <p>
          Morphology, our clued puzzle published on weekdays, is constructed by a rotating menagerie of talented individuals, many of whom have previously been published in <span className="italicText">The New York Times</span>, the <span className="italicText"> Los Angeles Times</span>, and other mainstream publications.
        </p>
        <p>
          We can be reached at <a target="_blank" href="mailto:editor@dailybaffle.com">editor@dailybaffle.com</a>.
        </p>
      </div>

      <Button className="returnHomeButton" variant="text" onClick={() => { navigate('/'); }}>
        Return to Main Page
      </Button>
    </div> 
  );
};

export default AboutPage;